import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8506_140)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.125 25.3286H3.6875C3.62125 25.3286 3.5575 25.3011 3.51125 25.2549C3.46375 25.2074 3.4375 25.1449 3.4375 25.0786C3.4375 25.0774 3.4375 23.2661 3.4375 23.2661C3.4375 22.2274 4.17875 21.3124 5.32125 20.5349C7.36125 19.1424 10.6625 18.2649 14.375 18.2649C14.9875 18.2649 15.5887 18.2899 16.1763 18.3361C16.6912 18.3774 17.1438 17.9924 17.185 17.4761C17.225 16.9599 16.84 16.5086 16.3237 16.4674C15.6888 16.4161 15.0387 16.3899 14.375 16.3899C10.2225 16.3899 6.54625 17.4286 4.26375 18.9849C2.5225 20.1724 1.5625 21.6811 1.5625 23.2649V25.0786C1.5625 25.6411 1.78625 26.1824 2.185 26.5811C2.58375 26.9786 3.12375 27.2036 3.6875 27.2024C6.2075 27.2036 13.125 27.2036 13.125 27.2036C13.6425 27.2036 14.0625 26.7824 14.0625 26.2661C14.0625 25.7486 13.6425 25.3286 13.125 25.3286Z"
        fill="var(--tlx-cta-primary-default)"
        stroke="var(--tlx-stroke-border-default)"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.375 1.5625C10.58 1.5625 7.5 4.6425 7.5 8.4375C7.5 12.2325 10.58 15.3125 14.375 15.3125C18.17 15.3125 21.25 12.2325 21.25 8.4375C21.25 4.6425 18.17 1.5625 14.375 1.5625ZM14.375 3.4375C17.135 3.4375 19.375 5.6775 19.375 8.4375C19.375 11.1975 17.135 13.4375 14.375 13.4375C11.615 13.4375 9.375 11.1975 9.375 8.4375C9.375 5.6775 11.615 3.4375 14.375 3.4375Z"
        fill="var(--tlx-cta-primary-default)"
        stroke="var(--tlx-stroke-border-default)"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.69 25.2601C24.205 25.4876 25.8062 25.0176 26.9725 23.8514C28.925 21.8989 28.925 18.7289 26.9725 16.7776C25.0212 14.8251 21.8512 14.8251 19.8987 16.7776C18.7325 17.9439 18.2625 19.5451 18.49 21.0614L15.5875 23.9626C15.4113 24.1389 15.3125 24.3776 15.3125 24.6264V27.5001C15.3125 28.0176 15.7325 28.4376 16.25 28.4376H19.1237C19.3725 28.4376 19.6112 28.3389 19.7875 28.1626L22.69 25.2601ZM22.625 23.3351C22.3025 23.2489 21.9575 23.3414 21.7213 23.5776L18.7363 26.5626H17.1875V25.0139L20.1725 22.0289C20.4088 21.7926 20.5013 21.4476 20.415 21.1251C20.1375 20.0814 20.4062 18.9214 21.225 18.1026C22.445 16.8826 24.4262 16.8826 25.6475 18.1026C26.8675 19.3239 26.8675 21.3051 25.6475 22.5251C24.8287 23.3439 23.6688 23.6126 22.625 23.3351Z"
        fill="var(--tlx-cta-primary-default)"
        stroke="var(--tlx-stroke-border-default)"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4776 21.2725C21.9489 20.7438 21.9489 19.885 22.4776 19.3563C23.0064 18.8275 23.8651 18.8275 24.3939 19.3563C24.9226 19.885 24.9226 20.7438 24.3939 21.2725C23.8651 21.8013 23.0064 21.8013 22.4776 21.2725Z"
        fill="var(--tlx-cta-primary-default)"
      />
    </g>
    <defs>
      <clipPath id="clip0_8506_140">
        <rect width="30" height="30" fill="var(--tlx-surface-bg-surface)" />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
